module.exports = __webpack_public_path__ + "static/media/banner-silestone-background.451826eb.png";